import Cookies from 'js-cookie'

const TokenKey = 'satoken'
export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function setUserInfo(userInfo) {
  localStorage.setItem('userInfo', JSON.stringify(userInfo))
}

export function removeUserInfo() {
  localStorage.removeItem('userInfo')
}
export function getCachedUserInfo() {
  try {
    const userInfo = localStorage.getItem('userInfo')
    return userInfo ? JSON.parse(userInfo) : {}
  } catch (error) {
    return {}
  }
}
